exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-survey-window{height:400px}#asseco-survey-window .asseco-list-item-label{width:calc(100% - 40px);display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports
